import { supabase } from '../supabase/client';
import { User } from '@/types/auth';

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return null;

    const { data: userData, error } = await supabase
      .from('users')
      .select('*')
      .eq('id', session.user.id)
      .single();

    if (error) throw error;
    return userData;
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};

export const isFirstTimeLogin = async (userId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('users')
      .select('first_login')
      .eq('id', userId)
      .single();

    if (error) throw error;
    return data?.first_login ?? true;
  } catch (error) {
    console.error('Error checking first time login:', error);
    return true;
  }
};

export const hasRequiredPermissions = (
  userRole: string | undefined,
  requiredRoles: string[]
): boolean => {
  if (!userRole) return false;
  return requiredRoles.includes(userRole);
};